<template>
  <div>
    <div v-for="resource of stats" :key="resource.name" class="tw-mb-5">
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
        <h3 class="bk-section-title tw-text-lg tw-mb-0">{{ resource.name }}</h3>
        <Button
          label="Refresh"
          icon="pi pi-refresh"
          class="p-button-outlined p-button-sm"
          @click="$emit('refresh')"
        />
      </div>
      <div class="tw-overflow-x-auto">
        <table class="bk-table bk-table--compact">
          <thead>
            <tr>
              <th>Source</th>
              <th>Destination</th>
              <th>Num records</th>
              <th>Most recent</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tw-italic">
              <td>MLS</td>
              <td />
              <td>{{ numRecordsInMls(resource.num_records_in_mls) }}</td>
              <td><display-datetime :datetime="resource.most_recent_at" /></td>
            </tr>
            <tr v-for="destination of resource.destinations" :key="destination.name">
              <td />
              <td>{{ destination.name }}</td>
              <td>
                {{ destination.num_records }}
                <StatusIcon
                  v-if="destination.num_records === resource.num_records_in_mls"
                  class="tw-mx-1"
                  :ok="true"
                  title="Matches the number of records in the MLS"
                />
                <span v-else>
                  <StatusIcon
                    class="tw-mx-1"
                    :ok="false"
                    title="Does not match the number of records in the MLS"
                  />
                  {{ differenceString(destination.num_records, resource.num_records_in_mls) }}
                </span>
              </td>
              <td>
                <display-datetime :datetime="destination.most_recent_at" />
                <StatusIcon
                  v-if="destination.most_recent_at && destination.most_recent_at === resource.most_recent_at"
                  class="tw-ml-1"
                  :ok="true"
                  title="Matches the most recent record in the MLS"
                />
                <StatusIcon
                  v-if="destination.most_recent_at && destination.most_recent_at !== resource.most_recent_at"
                  class="tw-ml-1"
                  :ok="false"
                  title="Does not match the most recent record in the MLS"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import StatusIcon from './StatusIcon'

export default {
  components: { StatusIcon },
  inject: ['jobsProvider'],
  props: {
    sourceName: String,
    stats: Array,
  },
  data() {
    return { jobsCountForSource: 0 }
  },
  methods: {
    numRecordsInMls(num) {
      if (num === 0) return 0
      return num || '?'
    },
    differenceString(destinationNumRecords, numRecordsInMls) {
      if (!numRecordsInMls) return ''
      if (destinationNumRecords < numRecordsInMls) {
        return `Missing ${numRecordsInMls - destinationNumRecords}`
      }
      return `Too many by ${destinationNumRecords - numRecordsInMls}`
    },
  },
  watch: {
    jobsProvider: {
      deep: true,
      handler(newValue) {
        const newJobsCountForSource = newValue.runningJobs.filter(x => x.sourceName === this.sourceName).length
        if (newJobsCountForSource < this.jobsCountForSource) {
          this.$emit('refresh')
        }
        this.jobsCountForSource = newJobsCountForSource
      },
    },
  },
}
</script>
